import { Link, Text } from '@ui/atoms';
import Accordion from '@components/Faq/accordion';
import { FAQs } from './utils/helper';

const Faq = () => {
    const addHashToUrl = (hashId) => {
        history.replaceState(null, '', `#${hashId}`);
    };

    return (
        <div className="bg-basicWhite ">
            <header
                id="faqsBanner"
                className="relative w-full px-4 pb-12 pt-24 overflow-hidden flex-center bg-[url('/images/homepage/why-bonds-bg.svg')] xl:bg-[length:130%] bg-[center_50%] xl:bg-[center_25%] bg-no-repeat bg-scale-y-[-1]"
            >
                <div className="z-10 flex flex-col md:items-center justify-center gap-1">
                    <Text
                        content="Frequently Asked Questions"
                        className="h4-semibold xl:h2-semibold text-basicWhite md:text-center"
                        htmlTag='h1'
                        isInnerHtml
                    />
                    <Text
                        content="Here are answers to questions that we get asked most about investing in Jiraaf"
                        className="text-basicWhite p5-regular xl:p4-regular md:text-center"
                    />
                </div>
            </header>
            <div className="page-wrapper w-full px-4 !py-3 mx-auto md:px-16 lg:px-12 xl:px-40 md:py-5 ">
                {FAQs.map((section, index) => (
                    <div key={index}>
                        {section?.isMainHeader ? (
                            <div onClick={() => addHashToUrl(section?.mainHeader)}>
                                <Text
                                    id={section?.id}
                                    content={section?.mainHeader}
                                    className="mt-8 h4-semibold md:h2-semibold text-primary-500"
                                    htmlTag='h2'
                                />
                            </div>
                        ) : (
                            <Accordion section={section} />
                        )}
                    </div>
                ))}
                <div>
                    <p className="my-8 text-xs md:text-sm text-primary-500">
                        All investment opportunities on Jiraaf platform carry
                        risk and investors should carefully evaluate whether the
                        opportunity is suitable for them before making the
                        investments. Please read detailed risk factors available
                        at{' '}
                        <span className="font-semibold">
                            <Link
                                href={`${process.env.NEXT_PUBLIC_APP_URL}/risk-disclosure`}
                                target={'_blank'}
                                gtmTag={'gtm-click-risk-disclosure'}
                            >
                                {`${process.env.NEXT_PUBLIC_APP_URL}/risk-disclosure`}
                            </Link>
                        </span>{' '}
                        before making an investment.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Faq;
